import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { ModalDirective } from 'ng-uikit-pro-standard/lib/free/modals/modal.directive';
import { FormGroup, FormBuilder, Validators, FormControl } from "@angular/forms";
import { TipoDTEService } from 'src/app/services/tipo-dte.service';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { ToastService } from 'ng-uikit-pro-standard';

@Component({
  selector: 'app-modal-add-referencia',
  templateUrl: './modal-add-referencia.component.html',
  styleUrls: ['./modal-add-referencia.component.scss'],
  providers: [SecurityService]
})
export class ModalAddReferenciaComponent implements OnInit {

    // OPTIONS
    optionsDoctoReferencia: Array<any> = [];

    public rutEmpresa: number


    // Modales
    @ViewChild('AddDocReferencia', { static: true })
    AddDocRef: ModalDirective;

    @Output() onListaDoc: EventEmitter<any> = new EventEmitter<any>()
    public correlativo: number = 1;


     // Form
  formHeader: FormGroup

    //VARIABLES PARA MODAL TABLE
    listDocRef: Array<any> = [];
    listaDoc: any = [];
    fechaDocClient: string = null;
    band: number = 0;

  constructor(
    private fb: FormBuilder,
    private tipoDteService:TipoDTEService,
    private formValidatorsService: FormValidatorsService,
    private accesolocalstorage: SecurityService,
    private toastService: ToastService

  ) { }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());

    this.loadComboDoctoRef();
    this.createForm();
  }

  private loadComboDoctoRef() {
    // Tipos documentos
    this.tipoDteService.ObtenerTipoDocOrderCompra(({ respuesta }) => {
      const { registros } = respuesta
      this.optionsDoctoReferencia = registros.map(tipo => ({ value: tipo.codigo, label: tipo.nombre, ...tipo }))
         this.formValidatorsService.selectDefaultFormatoProducto(this.formHeader.get('TipoDoc'), this.optionsDoctoReferencia)
    })
  }

  //MOSTRAR MODAL PARA AGREGAR DOC
  show(listadeDocRef, fechaDocCliente){
    this.fechaDocClient = fechaDocCliente
    this.formHeader.get('FechaDoc').setValue(this.fechaDocClient);

    this.listaDoc = listadeDocRef;
    this.listaDoc.map(detalle => {
        detalle.checked = false
    });

    this.AddDocRef.show();
  }

  // OCULTAR O CERRAR MODAL DE DOC ADD
  hide(){
    this.LimpiarForm();
    this.AddDocRef.hide();
  }

  //CREAR FORMULARIO
  private createForm() {

    this.formHeader = this.fb.group({
      TipoDoc: [null,[Validators.required]],
      NroDoc:[null,[Validators.required]],
      FechaDoc:[this.fechaDocClient,[Validators.required]],
      Razonref:[null,[Validators.required]]
    });
  }

  //GUARDAR FORMULARIO
  public GuardarFormulario(){
    const { TipoDoc, NroDoc, FechaDoc, Razonref } = this.formHeader.value

    this.formValidatorsService.validateAllFormFields(this.formHeader)
      if (!this.formHeader.valid) {
        this.toastService.warning('Complete la información requerida')
        return
      }

    // -- LA FECHA NO PUEDE SER MENOR A LA FECHA ACTUAL




    if(this.listaDoc.length === 0){
      this.listaDoc = [];
      this.listDocRef = [];
    }

    const params = {
      tipo_dte_codigo_referencia: TipoDoc,
      tipo_dte_codigo_nombre: this.optionsDoctoReferencia.filter(opt => opt.value === this.formHeader.get('TipoDoc').value)[0].label,
      folio_referencia: 0,
      folio_str: NroDoc,
      fecha_ref: FechaDoc,
      razon_ref: Razonref,
      rut_emisor_referencia: this.rutEmpresa,
      checked: false,
      index: this.correlativo
    }

    this.correlativo++;


    //VALIDACIONES

    // -- NO SE PUEDE GUARDAR N° DOC IGUALES
    for (let i = 0; i < this.listDocRef.length; i++) {
      const doc = this.listDocRef[i];

      if(doc.folio_str === NroDoc){
        this.toastService.warning('Este folio existe en la lista.')
        this.band = 1;
        break; // si el folio es igual, detener
      }else{
        this.band = 0;
      }
    }

    if(this.listaDoc.length > 0 && this.band === 0){
      this.listaDoc.push(params);
      this.onListaDoc.emit(this.listaDoc);
      this.hide();
    }else{
      if(this.band === 0){
        this.listDocRef.push(params);
        this.onListaDoc.emit(this.listDocRef);
        this.hide();
      }
    }
}

  //LIMPIAR FORMULARIO
  public LimpiarForm(){
    this.formHeader.reset();
    this.formValidatorsService.selectDefaultFormatoProducto(this.formHeader.get('TipoDoc'), this.optionsDoctoReferencia)
    this.formHeader.get('NroDoc').setValue(null);
    this.formHeader.get('FechaDoc').setValue(this.fechaDocClient);
    this.formHeader.get('Razonref').setValue(null);
  }
}
